<template>
  <div style="display: inline-block;">
    <span @click="show()" :id="'exception'+order.id">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" class="el-dialog-sm custom-dialog" top="0" :close-on-click-modal="false" :modal="!mobiletype" :visible.sync="dialogFormVisible" width="90%" @close="init()">
      <div :class="{mobile_upload_order:mobiletype}">
        <el-tabs v-model="currentTab" class="customtab" v-if="order.exception_list.length" @tab-click="handleClick">
          <el-tab-pane v-for="(t,index) in order.exception_list" :label="t.type_name+(t.status==2?'(已关闭)':'')" style="padding:10px;" :key="index">
            <!--<div class="ex-row">
              {{ t.type_name }} 
            </div>-->
            <ul class="error-messages" v-if="t.error">
              <li>{{t.error}}</li>
            </ul>
            <div class="ex-row" v-if="t.need_select_product=='Y'">
              <div style="line-height: inherit;">
                <ProductList :groupOrderLine="groupOrderLine" :checkDisabled="true"
                :order="order" :numEditable="false" :operation="'商品'"></ProductList>
              </div>
            </div>
            <div class="ex-row" style="max-height:250px;">
              <div class="ex-item" v-for="(row,index) in remarkList" :key="index">
                <template v-if="index==0">
                  <div style="width:95px;text-align: center;">
                    <span style="font-size: 12px;word-break: keep-all;">{{ t.create_time }}</span>
                  </div>
                  <div style="flex:1;padding-left:5px;">
                    <span style="margin-right:5px;font-size: 12px;">{{ t.create_account_name }}</span>
                    <span style="font-size: 12px;">
                      <template v-if="index==0 && t.need_send_sms=='Y'">
                        <img style="margin-right:3px;width:20px;height:20px;position: relative;top:4px;" v-if="t.send_sms_status==1" src="../../../../assets/images/sms-success.png"/>
                        <img style="margin-right:3px;width:20px;height:20px;position: relative;top:4px;" v-if="t.send_sms_status==2" src="../../../../assets/images/sms-error.png"/>
                      </template>
                      {{ row.content }}
                    </span>
                  </div>
                </template>
                <template v-else>
                  <div style="width:95px;text-align: center;">
                    <span style="font-size: 12px;word-break: keep-all;">{{ row.time }}</span>
                  </div>
                  <div style="flex:1;padding-left:5px;">
                    <span style="margin-right:5px;font-size: 12px;">{{ row.role=='1'?row.username:'用户' }}</span>
                    <span style="font-size: 12px;">
                      <template v-if="row.sms">
                        <img style="margin-right:3px;width:20px;height:20px;position: relative;top:4px;" v-if="row.sms_status" src="../../../../assets/images/sms-success.png"/>
                        <img style="margin-right:3px;width:20px;height:20px;position: relative;top:4px;" v-else src="../../../../assets/images/sms-error.png"/>
                      </template>
                      {{ row.content }}
                    </span>
                  </div>
                </template>
              </div>
            </div>
            <div v-if="t.ticket_id_list.length" class="ticket_div" @click="openTicket">
              查看工单详情
            </div>
            <div>
              <template v-if="t.status==1">
                <div v-show="!newRemarkMode" style="color:#0f66cf;cursor: pointer;" @click="newRemarkMode=true">添加信息</div>
              </template>
              <template v-if="newRemarkMode">
                <div>
                  <div style="margin:10px 0;">
                    <el-input v-model="newRemark" placeholder="添加信息" style="width:100%"></el-input>
                  </div>
                  <div style="margin:10px 0;line-height: 30px;display:flex;">
                    <el-checkbox v-model="need_send_sms" style="margin-right:10px;"></el-checkbox>
                    <div>
                      短信通知{{ clientName }}：{{ replyTemplateList[0].content.replace('{1}',order.order_no).replace('{3}',newRemark).replace('{2}',t.type_name)}}
                    </div>
                  </div>
                  <div style="display:flex;justify-content: space-between;">
                    <el-button style="width:45%;" class="nohover" size="small"  @click="newRemarkMode=false">取 消</el-button>
                    <el-button style="width:45%;" :loading="newRemarkLoading" size="small" type="info" @click="confirmNewRemark(t)">提 交</el-button>
                  </div>
                </div>
              </template>
            </div>
            <div style="margin-top:30px;">
              <el-button v-if="t.status!=2" style="width:100%;margin-bottom:10px" type="primary" class="nohover" slot="reference" @click="updateEx(2)">关闭{{ exception_type_name(t.category) }}</el-button>
              <!--<el-popover v-model="deleteDialog" trigger="click">
                <p style="margin:20px 10px">确定删除吗？</p>
                <div style="text-align: right;">
                  <el-button size="mini" type="text" @click="deleteDialog = false">取消</el-button>
                  <el-button :loading="loading" type="primary" size="mini" @click="updateEx(3)">确定</el-button>
                </div>
              </el-popover>-->
              <br v-if="t.status!=2">
              <el-button v-if="maishouenable"
               style="width:100%;" class="nohover" slot="reference" @click="updateEx(3)">删除{{ exception_type_name(t.category) }}</el-button>
            </div>

          </el-tab-pane>
        </el-tabs>
        <div style="margin:40px;" v-else>
          <p style="text-align:center;font-size:18px;">目前没有异常</p>
        </div>
      </div>
    </el-dialog>

    <el-dialog v-if="ticketShow" class="el-dialog-sm custom-width-dialog-900" top="0" :close-on-click-modal="false" :visible.sync="ticketShow" width="90%">
      <div>
        <h3 style="text-align: center;">工单号:{{ ticket.ticket_number }}</h3>
        <Ticket :r="ticket" :ticketStatus="ticketStatus" :ticketVisible="ticketVisible"
        :ticketPriorities="ticketPriorities" :singleList="singleList" :ticketTypes="ticketTypes"></Ticket>
        <div style="clear:both;"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../../../services/api.js'
import YueDanIpt from '../../../../components/YueDanIpt'
import ProductList from './ExceptionProductList'
import Ticket from '../../ticket/TicketBody'
import {errorMessage} from '../../../../services/error.js'
let _ = require('lodash')

export default {
  name: 'Exception',
  props: ['order', 'mobiletype','addExcetion','maishouenable','ticketStatus','ticketPriorities','singleList','ticketTypes','ticketVisible','exceptionTypes','replyTemplateList','currentEx'],
  components: {
    YueDanIpt: YueDanIpt,
    ProductList,
    Ticket:Ticket
  },
  data () {
    return {
      newRemarkMode:false,
      newRemarkLoading:false,
      ticket:{},
      dialogFormVisible:false,
      ticketShow:false,
      account_id:this.$localStorage.get('account_id'),
      loading: false,
      deleteDialog:false,
      current:0,
      currentTab:'0',
      closeDialog:false,
      groupOrderLine:[],
      newRemark:'',
      remarkList:[],
      need_send_sms:true
    }
  },
  computed:{
    globalUserInfo() {
        return this.$store.state.userInfo
    },
    clientName(){
      console.log('edit',this.exceptionTypes)

      let t=this.exceptionTypes.filter(i=>i.value==this.order.exception_list[this.current].type)
      if(t.length){
        return t[0].target_role_list.map((i)=>{
          switch(i.value){
            case 1:
              return this.order.buyer_username;
            case 2:
              return this.order.transport_shipping_username;
            case 3:
              return this.order.buyer_delegate_username;
          }
        }).join(',')
      }
      else
        return ''
    }
  },
  methods: {
    generateNowDisplay(){
      let today=new Date()
      let today_string=this.$moment(today).format('YYYY-MM-DD HH:mm:ss')
      return today_string
    },
    async confirmNewRemark(ex){
      if(!this.newRemark)
        return
      this.newRemarkLoading=true;
      let newRemarkTotal = ex.description;
      let onlyNewPart = '&remark&'+this.globalUserInfo.username+'^&*'+this.generateNowDisplay()+'^&*'+this.newRemark+'^&*1'
      if(this.need_send_sms)
        onlyNewPart+='^&*Y'
      else
        onlyNewPart+='^&*N'
      onlyNewPart+='^&*1'
      newRemarkTotal+=onlyNewPart
      let data={
        id:+ex.id,
        description:onlyNewPart,
        need_send_sms:this.need_send_sms?'Y':'N',
        reply_content:this.newRemark,
      }
      let res = await api.post(this, {
            path: 'order_exception.php',
            api: 'update_description',
            data: data,
            loading: 'loading'
          })
          this.newRemarkLoading=false;
          res = res.body
          if (res.status == 'ok') {
            this.newRemarkMode=false
            ex.description=newRemarkTotal
            ex.send_sms_status=res.result.find(i=>i.id==ex.id).send_sms_status
            this.newRemark=''
            this.order.update_time=res.result[0].update_time
            this.formatRemark(ex.description)
          }
    },
    formatRemark(desc){
      this.remarkList=[]
      let remarkArr=desc.split('&remark&');
      remarkArr.forEach((a)=>{
        let r = a.split('^&*');
        if(r.length>=3){
          let sms = false
          let sms_status = true
          if(r.length==6)
            sms = r[4]=='Y'?true:false
          else
            sms = false
          if(sms){
            sms_status=this.order.exception_list[this.current].send_sms_status=='1'?true:false
          }
          this.remarkList.push({username:r[0],time:r[1],content:r[2],role:r[3]?r[3]:'1',sms:sms,sms_status:sms_status})
        }
        else{
          this.remarkList.push({content:r[0]})
        }
      })
    },
    exception_type_name(t){
      switch(t){
        case "1":
          return '异常';
        case "4":
          return '通知';
        default:
          return '提示';
      }
    },
    generateDateDisplay(datestring){
      let today=new Date()
      let yesterday=new Date(today.getTime() -24*60*60*1000)
      let today_string=this.$moment(today).format('YYYY-MM-DD')
      let yest_string=this.$moment(yesterday).format('YYYY-MM-DD')
      if(datestring==today_string)
        return '今天';
      if(datestring==yest_string)
        return '昨天';
      return datestring
    },
    async openTicket(){
      this.dialogFormVisible=false;
      this.ticketShow=true

      let exid=+this.order.exception_list[this.current].id
      let params={}
      params.order_exception_id=exid
      params.page=1
      params.limit=99
      let res=await api.getTicketList(this,params)
      let t=res.body.result[0]
      if(t.created_date){
        t.createDateDisplay=this.generateDateDisplay(t.created_date.split(' ')[0])
        t.createTimeDisplay=t.created_date.split(' ')[1]
      }
      let commentsres = await api.getTicketComments(this, {ticket_id:t.id})
      t.comments=commentsres.body.result
      t.comments.forEach((o,index)=>{
        o.replyDateDisplay=this.generateDateDisplay(o.replied_date.split(' ')[0])
        o.replyTimeDisplay=o.replied_date.split(' ')[1]  
      })
      this.ticket=t
    },
    handleClick(tab, event) {
      this.current=+tab.index
      this.generateLine();
      this.formatRemark(this.order.exception_list[this.current].description);
    },
    async show () {
        this.goods_info = [
          { image: '', remark: '', id: new Date().getTime() }
        ]
        this.current = this.currentEx
        this.formatRemark(this.order.exception_list[this.current].description);
        this.currentTab=this.current+'';
        console.log('current',this.current,this.currentTab)
        this.dialogFormVisible = true
        this.generateLine()
    },
    format(spec){
      if(!spec)
        return ''
      try{
        spec=spec.replace(/\n/g,'')
        spec = JSON.parse(spec)
        if(spec.spec){
          //如果是手动填写规格，则直接使用
          return spec.spec.replace(/\n/g,'');
        }
        else
          return JSON.stringify(spec)
      }
      catch(error){
        return ''
      }
    },
    generateLine(){
      this.groupOrderLine = []
      let goods=this.order.exception_list[this.current].product_list.map((i)=>{return {id:i.id,spec:i.specification,number:i.number}})
      _.each(this.order.goods_list, item => {
          let g=goods.filter(i=>{
            if(item.spec && i.spec){
              let spec=''
              let ts=''
              try{
                ts=this.format(item.spec)
                spec=JSON.stringify(i.spec).replace(/\//g, '/')
              }
              catch(error){
                spec=''
              }
              if(spec)
                return i.id==item.id && ts==spec
              else
                return i.id==item.id
            }
            else
              return i.id==item.id
          })
          if(g.length){
            item.selectNum=g[0].number
            item.checked=true
            this.groupOrderLine.push(item) 
          }
      })
    },
    init () {
      this.isEmptyErrors = true
    },
    /*openDelete(index){
      this.deleteDialog=true
      this.current=index
    },*/
    async updateEx(status){
      this.order.exception_list[this.current].error=''
      let data={id:+this.order.exception_list[this.current].id,status:status}
      let res = await api.post(this, {
            path: 'order_exception.php',
            api: 'update_status',
            data: data,
            loading: 'loading'
          })
          res = res.body
          if (res.status == 'ok') {
            if(status==3){
              this.deleteDialog=false;
              //this.dialogFormVisible=false;
              this.order.exception_list.splice(this.current,1)
              this.current=0;
              this.currentTab=this.current+''
              if(this.order.exception_list.length){
                this.generateLine();
                this.$emit('refreshEXList')
              }
            }
            else{
              this.closeDialog=false;
              this.order.exception_list[this.current].status=status;
              if(this.order.exception_list && this.order.exception_list.length>1){
                let id=this.order.exception_list[this.current].id
                this.order.exception_list.sort((a,b)=>{
                  return (+a.status)-(+b.status)
                })
                this.current=this.order.exception_list.findIndex(i=>i.id==id)
                this.currentTab=this.current+''
              }
              this.$forceUpdate()
            }
          }
          else{
            this.order.exception_list[this.current].error=errorMessage[res.result]?errorMessage[res.result]:'数据错误'
            this.$forceUpdate()
          }
          this.$emit('updateOrder')

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .ex-item{
    padding:20px 10px;
    display: flex;
    line-height: 20px;
  }
  .ex-item:nth-child(odd) {
    background-color: #f3f3f9;
  }
  .error-messages {
    display: block;
    background-color: #fff1f1;
    padding: 10px;
    text-align: center;
    color: #ff4650;
    line-height: 17px;
    margin-bottom: 10px;
    border-radius: 5px;
    li {
      font-size: 12px;
    }
  }
  .dialog-form {
    padding-bottom: 20px;
  }
  .tip {
    font-size: 12px;
    color: #888888;
    line-height: 16px;
  }
  .mobile_upload_order {
    padding: 0 10px !important;
  }
  .clearHistory{
    float: right;
    padding:0;
    font-size: 14px;
    color:#1066CF;
  }
  .ex-row{
    margin-bottom:10px;
    max-height: 300px;
    overflow: auto;
  }
  .ticket_div{
    margin-top:20px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/single/ExceptionManage.vue